<template>
  <div>
    <template v-if="disabled">
      <span class="text-primary">{{ data | dateTimeFormat }}</span>
    </template>
    <flat-pickr
      v-else
      v-model="data"
      :disabled="disabled"
      :placeholder="$t('_components.placeholder.select') + label"
      class="form-control"
      :config="config"
    />
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'

export default {
  components: {
    flatPickr,
  },
  filters: {
    dateTimeFormat(date) {
      const resDate = moment(date).format('DD MM YYYY')
      return resDate
    },
  },
  props: {
    value: {
      type: [String, Number, Object, Array, Boolean],
      default: undefined,
    },
    option: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      data: undefined,
      config: {
        enableTime: true,
        // dateFormat: 'H:i, d M Y',
        dateFormat: 'Y-m-d H:i',
        allowInput: true,
        minDate: this.option.minDate,
        maxDate: this.option.maxDate,
      },
    }
  },
  watch: {
    data: {
      deep: true,
      handler(e) {
        if (this.getCharCount(e, ':') < 2) {
          this.$emit('input', `${e}:00`)
        } else {
          this.$emit('input', e)
        }
      },
    },
    value: {
      handler(e) {
        this.data = e
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    getCharCount(str, char) {
      const regex = new RegExp(char, 'g') // 使用g表示整个字符串都要匹配
      const result = str.match(regex) // match方法可在字符串内检索指定的值，或找到一个或多个正则表达式的匹配。
      const count = !result ? 0 : result.length
      return count
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
